import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=4fb17d51&scoped=true&"
import script from "./Workshop.vue?vue&type=script&lang=js&"
export * from "./Workshop.vue?vue&type=script&lang=js&"
import style0 from "./Workshop.vue?vue&type=style&index=0&id=4fb17d51&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb17d51",
  null
  
)

export default component.exports